import React, { useEffect } from 'react';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from './ui/dialog';
import { Button } from './ui/button';

const ContactModal = ({ children }) => {
  useEffect(() => {
    // Load formnx scripts
    const loadScripts = () => {
      if (!document.getElementById('formnx-resizer')) {
        const resizerScript = document.createElement('script');
        resizerScript.id = 'formnx-resizer';
        resizerScript.src = 'https://formnx.com/js/iframeResizer.js';
        document.body.appendChild(resizerScript);
      }
      
      if (!document.getElementById('formnx-widget')) {
        const widgetScript = document.createElement('script');
        widgetScript.id = 'formnx-widget';
        widgetScript.src = 'https://formnx.com/js/widget.js';
        document.body.appendChild(widgetScript);
      }
    };
    
    loadScripts();
  }, []);

  return (
    <Dialog>
      <DialogTrigger asChild>
        {children}
      </DialogTrigger>
      <DialogContent className="sm:max-w-[600px] max-h-[90vh] overflow-y-auto bg-white">
        <DialogHeader>
          <DialogTitle className="text-2xl font-bold text-[#1a2e4a] tracking-tight">
            Get in Touch
          </DialogTitle>
        </DialogHeader>
        <div className="mt-4">
          <iframe
            id="formnx-78fh16-uai45q0c"
            src="https://fill.formnx.com/f/contact-form-78fh16?iframe=true"
            frameBorder="0"
            style={{ width: '1px', minWidth: '100%', minHeight: '400px' }}
            title="Contact Form"
          />
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default ContactModal;
